import './assets/css/vendor/bootstrap.min.css';
import './assets/css/vendor/bootstrap.rtl.only.min.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-image-lightbox/style.css';
import 'react-vertical-timeline-component/style.min.css';
import 'video.js/dist/video-js.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'react-sweet-progress/lib/style.css';
import 'react-tabs-scrollable/dist/rts.css';
import 'react-day-picker/dist/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-tagsinput/react-tagsinput.css';
import 'rc-slider/assets/index.css';
import 'rc-switch/assets/index.css';
import 'reactjs-popup/dist/index.css';
import 'react-data-grid/lib/styles.css';
import { isMultiColorActive, defaultColor, isDarkSwitchActive } from './constants/defaultValues';
import { getCurrentColor, setCurrentColor } from './helpers/utils';
import 'moment/locale/es';
import serviceWorkerUpdates from './helpers/serviceWorkerUpdates';

const color = isMultiColorActive || isDarkSwitchActive ? getCurrentColor() : defaultColor;
setCurrentColor(color);

const render = () => {
  import(`./assets/css/sass/themes/gogo.${color === '' || !color ? 'light.greenmoss' : color}.scss`).then(() => {
    require('./AppRenderer');
  });
};
render();

serviceWorkerUpdates();
